import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PlaceSuggestion } from '@app/interfaces/google-maps.interface';

type ScrollDirection = 'up' | 'down';

const SCROLL_AMOUNT_PX = 150;

@Component({
  selector: 'am-places-autocomplete-result-list',
  templateUrl: './result-list.component.html',
  styleUrls: ['./result-list.component.scss'], 
  standalone: false,
})
export class ResultListComponent {
  @Input() results: PlaceSuggestion[] | null = [];
  @Input() searchTerm = '';
  @Output() placeSelected = new EventEmitter<PlaceSuggestion>();

  @ViewChild('listContainer') listContainer!: ElementRef<HTMLElement>;

  scroll(direction: ScrollDirection) {
    if (!this.listContainer) return;

    const container = this.listContainer.nativeElement;
    const currentScroll = container.scrollTop;

    container.scrollTo({
      top:
        direction === 'down' ? currentScroll + SCROLL_AMOUNT_PX : currentScroll - SCROLL_AMOUNT_PX,
      behavior: 'smooth',
    });
  }

  onSelect(place: PlaceSuggestion) {
    this.placeSelected.emit(place);
  }
}
